import { computeMyDriverUnreadCount, myDriverUnreadCountCollections } from "@/models/repositories/Driver";
import { useCollectionsCompute } from "@/store/useCollectionsCompute";
import { isInitialDriverLoadPending } from "./initialDriverLoadPending";

export function useMyDriverUnreadCount(workspaceId: string, membershipId: string | undefined, teamAliases: string[]) {
  const count = useCollectionsCompute(
    myDriverUnreadCountCollections,
    () => (workspaceId && membershipId ? computeMyDriverUnreadCount({ workspaceId, membershipId, teamAliases }) : null),
    [workspaceId, membershipId, teamAliases.join(",")],
    "DriverView:myDriverUnreadCount",
  );
  return {
    count: count ?? 0,
    // Scans every item row (bool_or per feed), so it belongs to the first-render battery the
    // driver view blocks interaction on (WEB-2144).
    initialLoadPending: isInitialDriverLoadPending({ workspaceId, membershipId, results: [count] }),
  };
}
